import React, { useState, useEffect } from "react";
import { Box, FormControl, Grid, MenuItem, Select, Stack, TextField, ToggleButton, 
  ToggleButtonGroup, Typography, Divider, Button, IconButton, InputLabel, 
  Tooltip} from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';

export default function SystemControlPanelDetails({
  DomesticInternational,
  PrimaryCommunicationsConnectionType,
  BackupCommunicationsConnectionType,
  PointTopointPackage,
  PointTopointDetails,
  PrimaryEbutton,
  PrimaryEbuttonDetails,
  SensorPackageType,
  PlumbingInfrastructureType,
  ValveTypeSpecified,
  FireAlarmPanelInterconnect,
  MakeModelFireAlarmPanel,
  ColdWeatherPackage,
  ColdWeatherBsu,
  ConveyorStop,
  ArrangementResponsibleForConveyorStop,
  ConveyorStopDetectionDevice,
  ConveyorStopFireRoverOutput,
  ConveyorSirenStrobe,
  ConveyorStopSirenReset,
  ConveyorStopSirenResetInput,
  RiserRoomCamera,
  MakeModelPreactionValve,
  MakeModelPreactionPanel,
  SuppressionSolutionInductor,
  SuppressionSolutionSelection,
  BackupPowerGenerator,
  OutputConfigurations,
  InputConfigurations,
  AuxInputConfigurations,
  ViewingStation,
  ViewingStationDetail,
  ViewingStationLocation,
  CustomConfigurations,
  ProductionNoteConfigurations,
  onPanelDetailChange,
  selectedUnit
})
{
  const [domesticInternational, setDomesticInternational] = useState(DomesticInternational);
  const [primaryCommunicationsConnectionType, setPrimaryCommunicationsConnectionType] = useState(PrimaryCommunicationsConnectionType);
  const [backupCommunicationsConnectionType, setBackupCommunicationsConnectionType] = useState(BackupCommunicationsConnectionType);
  const [pointTopointPackage, setPointTopointPackage] = useState(PointTopointPackage);
  const [pointTopointDetails, setPointToPointDetails] = useState(PointTopointDetails);
  const [primaryEbutton, setPrimaryEbutton] = useState(PrimaryEbutton);
  const [primaryEbuttonDetails, setPrimaryEbuttonDetails] = useState(PrimaryEbuttonDetails);
  const [sensorPackageType, setSensorPackageType] = useState(SensorPackageType);
  const [plumbingInfrastructureType, setPlumbingInfrastructureType] =useState(PlumbingInfrastructureType);
  const [valveTypeSpecified, setValveTypeSpecified] = useState(ValveTypeSpecified);
  const [fireAlarmPanelInterconnect, setFireAlarmPanelInterconnect] = useState(FireAlarmPanelInterconnect);
  const [makeModelFireAlarmPanel, setMakeModelFireAlarmPanel] = useState(MakeModelFireAlarmPanel);
  const [coldWeatherPackage, setColdWeatherPackage] = useState(ColdWeatherPackage);
  const [coldWeatherBsu, setColdWeatherBsu] = useState(ColdWeatherBsu);
  const [conveyorStop, setConveyorStop] = useState(ConveyorStop);
  const [arrangementResponsibleForConveyorStop, setArrangementResponsibleForConvStop] = useState(ArrangementResponsibleForConveyorStop);
  const [conveyorStopDetectionDevice, setConveyorStopDetectionDevice] = useState(ConveyorStopDetectionDevice);
  const [conveyorStopFireRoverOutput, setConveyorStopFireRoverOutput] = useState(ConveyorStopFireRoverOutput);
  const [conveyorSirenStrobe, setConveyorSirenStrobe] = useState(ConveyorSirenStrobe);
  const [conveyorStopSirenReset, setConveyorStopSirenReset] = useState(ConveyorStopSirenReset);
  const [conveyorStopSirenResetInput, setConveyorStopSirenResetInput] = useState(ConveyorStopSirenResetInput);
  const [riserRoomCamera, setRiserRoomCamera] = useState(RiserRoomCamera);
  const [makeModelPreactionValve, setMakeModelPreactionValve] = useState(MakeModelPreactionValve);
  const [makeModelPreactionPanel, setMakeModelPreactionPanel] = useState(MakeModelPreactionPanel);
  const [suppressionSolutionInductor, setSuppressionSolutionInductor] = useState(SuppressionSolutionInductor);
  const [suppressionSolutionSelection, setSuppressionSolutionSelection] = useState(SuppressionSolutionSelection);
  const [backupPowerGenerator, setBackupPowerGenerator] = useState(BackupPowerGenerator);
  const [outputConfigurations, setOutputConfigurations] = useState(OutputConfigurations);
  const [inputConfigurations, setInputConfigurations] = useState(InputConfigurations);
  const [auxInputConfigurations, setAuxInputConfigurations] = useState(AuxInputConfigurations);
  const [viewingStation, setViewingStation] = useState(ViewingStation);
  const [viewingStationDetail, setViewingStationDetail] = useState(ViewingStationDetail);
  const [viewingStationLocation, setViewingStationLocation] = useState(ViewingStationLocation);
  const [customConfigurations, setCustomConfigurations] = useState(CustomConfigurations);
  const [productionNoteConfigurations, setProductionNoteConfigurations] = useState(ProductionNoteConfigurations);

useEffect(() => {
  onPanelDetailChange({
    domesticInternational,
    primaryCommunicationsConnectionType,
    backupCommunicationsConnectionType,
    pointTopointPackage,
    pointTopointDetails,
    primaryEbutton,
    primaryEbuttonDetails,
    sensorPackageType,
    plumbingInfrastructureType,
    valveTypeSpecified,
    fireAlarmPanelInterconnect,
    makeModelFireAlarmPanel,
    coldWeatherPackage,
    coldWeatherBsu,
    conveyorStop,
    arrangementResponsibleForConveyorStop,
    conveyorStopDetectionDevice,
    conveyorStopFireRoverOutput,
    conveyorSirenStrobe,
    conveyorStopSirenReset,
    conveyorStopSirenResetInput,
    riserRoomCamera,
    makeModelPreactionValve,
    makeModelPreactionPanel,
    suppressionSolutionInductor,
    suppressionSolutionSelection,
    backupPowerGenerator,
    outputConfigurations,
    inputConfigurations,
    auxInputConfigurations,
    viewingStation,
    viewingStationDetail,
    viewingStationLocation,
    customConfigurations,
    productionNoteConfigurations,
  });
// eslint-disable-next-line
}, [
  domesticInternational,
  primaryCommunicationsConnectionType,
  backupCommunicationsConnectionType,
  pointTopointPackage,
  pointTopointDetails,
  primaryEbutton,
  primaryEbuttonDetails,
  sensorPackageType,
  plumbingInfrastructureType,
  valveTypeSpecified,
  fireAlarmPanelInterconnect,
  makeModelFireAlarmPanel,
  coldWeatherPackage,
  coldWeatherBsu,
  conveyorStop,
  arrangementResponsibleForConveyorStop,
  conveyorStopDetectionDevice,
  conveyorStopFireRoverOutput,
  conveyorSirenStrobe,
  conveyorStopSirenReset,
  conveyorStopSirenResetInput,
  riserRoomCamera,
  makeModelPreactionValve,
  makeModelPreactionPanel,
  suppressionSolutionInductor,
  suppressionSolutionSelection,
  backupPowerGenerator,
  outputConfigurations,
  inputConfigurations,
  auxInputConfigurations,
  viewingStation,
  viewingStationDetail,
  viewingStationLocation,
  customConfigurations,
  productionNoteConfigurations,
]);

  const domesticInternationalList = [
    { id: 0, name: "Domestic (120V)" },
    { id: 1, name: "International (240V)" },
  ];

  const sensorPackageTypeList = [
    { id: 0, name: "180" },
    { id: 1, name: "360" },
  ];

  const primaryCommunicationsList = [
    { id: 0, name: "Dedicated Wan" },
    { id: 1, name: "Customer Shared Wan" },
    { id: 2, name: "4G Cellular Primary -- $200 Plan -- 30 GB Included" },
    { id: 3, name: "Starlink" },
    { id: 4, name: "Other" },
  ];

  const backupCommunicationsList = [
    { id: 0, name: "Dedicated Wan" },
    { id: 1, name: "Customer Shared Wan" },
    { id: 2, name: "4G Cellular -- $0 Plan -- 100 MB Included" },
    { id: 3, name: "4G Cellular --$100 Plan --  5 GB Included" },
    { id: 4, name: "Starlink" },
    { id: 5, name: "Other" },
    { id: 6, name: "None" },
  ];

  const plumbingInfrastructureList = [
    { id: 0, name: "Wet" },
    { id: 1, name: "Dry -- Unpressurized --  Electronically Activated" },
    { id: 2, name: "Dry -- Pressurized --  Electronically Activated" },
    { id: 3, name: "Dry -- Pressurized --  Air Loss Activated" },
    { id: 4, name: "Dry -- Pressurized --  Electronic or Air Loss Activated" },
    { id: 5, name: "Other" },
  ];

  const valveTypeList = selectedUnit.value === "BSU" ? [
    { id: 0, name: "EB20 Vic x Vic" },
    { id: 1, name: "AllValves CE 2'' FNPT x FNPT" },
    { id: 2, name: "Other" },
  ] : [
    { id: 0, name: "EB20 Vic x Vic" },
    { id: 1, name: "EB20 Vic x MNPT" },
    { id: 2, name: "EB20 Vic x FNPT" },
    { id: 3, name: "EB20 FNPT x FNPT" },
    { id: 4, name: "EB25 Vic x Vic" },
    { id: 5, name: "EB25 Vic x MNPT" },
    { id: 6, name: "EB25 Vic x FNPT" },
    { id: 7, name: "EB25 FNPT x FNPT" },
    { id: 8, name: "EB30 Vic x Vic" },
    { id: 9, name: "EB30 Vic x MNPT" },
    { id: 10, name: "EB30 Vic x FNPT" },
    { id: 11, name: "EB30 FNPT x FNPT" },
    { id: 12, name: "EB40 Vic x Vic" },
    { id: 13, name: "EB40 Vic x MNPT" },
    { id: 14, name: "EB40 Vic x FNPT" },
    { id: 15, name: "EB40 FNPT x FNPT" },
    { id: 16, name: "Other" },
  ];

  const suppressionSolutionList = [
    { id: 0, name: "F500" },
    { id: 1, name: "Water" },
    { id: 2, name: "Other" },
  ];

  const arrangementResponsibleForConvStopList = [
    { id: 0, name: "Arrangement 1" },
    { id: 1, name: "Arrangement 2" },
    { id: 2, name: "Arrangement 3" },
    { id: 3, name: "Arrangement 4" },
  ];

  const coldWeatherBsuList = [
    { id: 0, name: "Insulated Box Bottom" },
    { id: 1, name: "Insulated Box Bottom with 2nd Heater" },
    { id: 2, name: "Insulated Box Bottom with 2nd Heater No A/C" },
  ];

  const conveyorStopDetectionDeviceList = [
    { id: 0, name: "Thermal" },
    { id: 1, name: "IR3" },
    { id: 2, name: "Thermal and IR3" },
  ];

  const conveyorStopFireRoverOutputList = [
    { id: 0, name: "Output 1" },
    { id: 1, name: "Output 2" },
    { id: 2, name: "Output 3" },
    { id: 3, name: "Output 4" },
    { id: 4, name: "Output 5" },
    { id: 5, name: "Output 6" },
  ];

  const conveyorSirenStrobeList = [
    { id: 0, name: "Yes (D4100)" },
    { id: 1, name: "Yes (Other)" },
    { id: 2, name: "No" },
  ];

  const conveyorStopSirenResetInputList = [
    { id: 0, name: "Input 3" },
    { id: 1, name: "Input 4" },
    { id: 2, name: "Input 5" },
    { id: 3, name: "Input 6" },
  ];

  const outputConfigList = [
    { id: 0, name: "FACP Spray On Interconnect" },
    { id: 1, name: "Spray On - Any Arrangement" },
    { id: 2, name: "Trouble/Supervisory" },
    { id: 3, name: "Power or Primary Internet Loss" },
    { id: 4, name: "Power Loss" },
    { id: 5, name: "Primary Internet Loss" },
    { id: 6, name: "Primary Power Loss" },
    { id: 7, name: "Single Arrangement Spray On" },
    { id: 8, name: "E-Stop Output (Nitro/Spray/Left Temp/Right Temp)" },
    { id: 9, name: "Preaction Panel 2 Release" },
    { id: 10, name: "Other" },
    { id: 11, name: "N/A" },
  ];

  const circuitTypeList = [
    { id: 0, name: "NO (Normally Open)" },
    { id: 1, name: "NC (Normally Closed)" },
  ];

  const circuitMethodList = [
    { id: 0, name: "Momentary" },
    { id: 1, name: "Latching" },
  ];

  const inputPanelActionList = [
    { id: 0, name: "Alarm" },
    { id: 1, name: "Trigger Output" },
    { id: 2, name: "Log Only" },
    { id: 3, name: "Supervisory" },
  ];

  const inputConfigList = [
    { id: 0, name: "Heat Detector" },
    { id: 1, name: "Entrapment Button" },
    { id: 2, name: "System Spray Shutdown" },
    { id: 3, name: "Fire Alarm - Alarm" },
    { id: 4, name: "Fire Alarm - Supervisory" },
    { id: 5, name: "fire Alarm - Trouble" },
    { id: 6, name: "Fire Alarm - Water flow" },
    { id: 7, name: "E-Stop Reset" },
    { id: 8, name: "Central Station - Alarm" },
    { id: 9, name: "N/A" },
  ];

  const viewingStationDetailList = [
    { id: 0, name: "Beelink computer & 32'' monitor with desktop stand" },
    { id: 1, name: "Beelink computer & 55'' monitor and wall mount" },
    { id: 2, name: "N/A" },
  ];

  const addOutputConfiguration = () => {
    if (outputConfigurations.length < 6) {
      setOutputConfigurations([
        ...outputConfigurations,
        { id: outputConfigurations.length, value: "", notes: "" },
      ]);
    }
  };

  const handleOutputChange = (index, newValue) => {
    const newOutputConfigurations = [...outputConfigurations];
    newOutputConfigurations[index].value = newValue;
    setOutputConfigurations(newOutputConfigurations);
  };

  const handleNotesChange = (index, newNotes) => {
    const newOutputConfigurations = [...outputConfigurations];
    newOutputConfigurations[index].notes = newNotes;
    setOutputConfigurations(newOutputConfigurations);
  };

  const handleOtherTriggerChange = (index, otherTrigger) => {
    const newOutputConfigurations = [...outputConfigurations];
    newOutputConfigurations[index].otherOutputTrigger = otherTrigger;
    setOutputConfigurations(newOutputConfigurations);
  };

  const handleOutputCircuitTypeChange = (index, circuitType) => {
    const newOutputConfigurations = [...outputConfigurations];
    newOutputConfigurations[index].circuitType = circuitType;
    setOutputConfigurations(newOutputConfigurations);
  };

  const handleOutputCircuitMethodChange = (index, circuitMethod) => {
    const newOutputConfigurations = [...outputConfigurations];
    newOutputConfigurations[index].circuitMethod = circuitMethod;
    setOutputConfigurations(newOutputConfigurations);
  };

  const handleOutputResetMethodChange = (index, resetMethod) => {
    const newOutputConfigurations = [...outputConfigurations];
    newOutputConfigurations[index].resetMethod = resetMethod;
    setOutputConfigurations(newOutputConfigurations);
  };

  const handleInputCircuitTypeChange = (index, circuitType) => {
    const newInputConfigurations = [...inputConfigurations];
    newInputConfigurations[index].circuitType = circuitType;
    setInputConfigurations(newInputConfigurations);
  };

  const handleInputCircuitMethodChange = (index, circuitMethod) => {
    const newInputConfigurations = [...inputConfigurations];
    newInputConfigurations[index].circuitMethod = circuitMethod;
    setInputConfigurations(newInputConfigurations);
  };
  
  const handleInputResetMethodChange = (index, resetMethod) => {
    const newInputConfigurations = [...inputConfigurations];
    newInputConfigurations[index].resetMethod = resetMethod;
    setInputConfigurations(newInputConfigurations);
  };

  const handleInputPanelActionChange = (index, panelAction) => {
    const newInputConfigurations = [...inputConfigurations];
    newInputConfigurations[index].panelAction = panelAction;
    setInputConfigurations(newInputConfigurations);
  };

  const handleReportToCsChange = (index, reportToCs) => {
    const newInputConfigurations = [...inputConfigurations];
    newInputConfigurations[index].reportToCs = reportToCs;
    setInputConfigurations(newInputConfigurations);
  };

  const removeOutputConfiguration = (index) => {
    if (index > 0) {
      const newOutputConfigurations = outputConfigurations.filter(
        (_, i) => i !== index
      );
      setOutputConfigurations(newOutputConfigurations);
    }
  };

  const addInputConfiguration = () => {
    if (inputConfigurations.length < 4) {
      setInputConfigurations([
        ...inputConfigurations,
        { id: inputConfigurations.length, value: "", notes: "" },
      ]);
    }
  };

  const handleInputChange = (index, newValue) => {
    const newInputConfigurations = [...inputConfigurations];
    newInputConfigurations[index].value = newValue;
    setInputConfigurations(newInputConfigurations);
  };

  const handleInputNotesChange = (index, newNotes) => {
    const newInputConfigurations = [...inputConfigurations];
    newInputConfigurations[index].notes = newNotes;
    setInputConfigurations(newInputConfigurations);
  };

  const removeInputConfiguration = (index) => {
    if (index > 0) {
      const newInputConfigurations = inputConfigurations.filter(
        (_, i) => i !== index
      );
      setInputConfigurations(newInputConfigurations);
    }
  };

  const addAuxInputConfiguration = () => {
    if (auxInputConfigurations.length < 6) {
      setAuxInputConfigurations([
        ...auxInputConfigurations,
        { id: auxInputConfigurations.length, value: "", notes: "" },
      ]);
    }
  };

  const handleAuxInputChange = (index, newValue) => {
    const newAuxInputConfigurations = [...auxInputConfigurations];
    newAuxInputConfigurations[index].value = newValue;
    setAuxInputConfigurations(newAuxInputConfigurations);
  };

  const handleAuxInputNotesChange = (index, newNotes) => {
    const newAuxInputConfigurations = [...auxInputConfigurations];
    newAuxInputConfigurations[index].notes = newNotes;
    setAuxInputConfigurations(newAuxInputConfigurations);
  };

  const removeAuxInputConfiguration = (index) => {
    if (index > 0) {
      const newAuxInputConfigurations = auxInputConfigurations.filter(
        (_, i) => i !== index
      );
      setAuxInputConfigurations(newAuxInputConfigurations);
    }
  };

  const addCustomConfiguration = () => {
    if (customConfigurations.length < 4) {
      setCustomConfigurations([
        ...customConfigurations,
        { id: customConfigurations.length, notes: "" },
      ]);
    }
  };

  const handleCustomNotesChange = (index, newNotes) => {
    const newCustomConfigurations = [...customConfigurations];
    newCustomConfigurations[index].notes = newNotes;
    setCustomConfigurations(newCustomConfigurations);
  };

  const removeCustomConfiguration = (index) => {
    if (index > 0) {
      const newCustomConfigurations = customConfigurations.filter(
        (_, i) => i !== index
      );
      setCustomConfigurations(newCustomConfigurations);
    }
  };

  const addProductionNoteConfiguration = () => {
    if (productionNoteConfigurations.length < 4) {
      setProductionNoteConfigurations([
        ...productionNoteConfigurations,
        { id: productionNoteConfigurations.length, notes: "" },
      ]);
    }
  };

  const handleProductionNotesChange = (index, newNotes) => {
    const newProductionNoteConfigurations = [...productionNoteConfigurations];
    newProductionNoteConfigurations[index].notes = newNotes;
    setProductionNoteConfigurations(newProductionNoteConfigurations);
  };

  const removeProductionNoteConfiguration = (index) => {
    if (index > 0) {
      const newProductionNoteConfigurations = productionNoteConfigurations.filter(
        (_, i) => i !== index
      );
      setProductionNoteConfigurations(newProductionNoteConfigurations);
    }
  };

  return (
    <>
      <Box>
        <Typography variant="h4" gutterBottom>
          System / Control Panel Details
        </Typography>
        <Divider />
        <Grid container spacing={2}>
            <Grid item xs={12} style={{ paddingBottom: "3%", paddingTop: "8%" }}>
              <Stack direction="row" alignItems="center">
                <Typography variant="h6" style={{ minWidth: "35%" }}>
                  Domestic/International Power
                </Typography>

                <Box style={{ flexGrow: "1", minWidth: "60%" }}>
                  <FormControl sx={{ width: "40%" }}>
                    <Select
                      labelId="domestic/international"
                      id="domestic/international"
                      value={domesticInternational}
                      onChange={(event) => {
                        setDomesticInternational(event.target.value);
                      }}
                      sx={{ padding: "0px", maxHeight: "45px" }}
                    >
                      {domesticInternationalList.map((pm) => (
                        <MenuItem key={pm.id} value={pm.name}>
                          {pm.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>
              </Stack>
            </Grid>

          <Grid item xs={12} style={{ paddingBottom: "3%" }}>
            <Stack direction="row" alignItems="center">
              <Typography variant="h6" style={{ minWidth: "35%" }}>
                Primary Communications Connection Type
              </Typography>

              <Box style={{ flexGrow: "1", minWidth: "60%" }}>
                <FormControl sx={{ width: "40%" }}>
                  <Select
                    labelId="primary communications"
                    id="primary communications"
                    value={primaryCommunicationsConnectionType}
                    onChange={(event) => {
                      setPrimaryCommunicationsConnectionType(
                        event.target.value
                      );
                    }}
                    sx={{ padding: "0px", maxHeight: "45px" }}
                  >
                    {primaryCommunicationsList.map((pm) => (
                      <MenuItem key={pm.id} value={pm.name}>
                        {pm.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
            </Stack>
          </Grid>

          <Grid item xs={12} style={{ paddingBottom: "3%" }}>
            <Stack direction="row" alignItems="center">
              <Typography variant="h6" style={{ minWidth: "35%" }}>
                Backup Communications Connection Type
              </Typography>

              <Box style={{ flexGrow: "1", minWidth: "60%" }}>
                <FormControl sx={{ width: "40%" }}>
                  <Select
                    labelId="backup communications"
                    id="backup communications"
                    value={backupCommunicationsConnectionType}
                    onChange={(event) => {
                      setBackupCommunicationsConnectionType(event.target.value);
                    }}
                    sx={{ padding: "0px", maxHeight: "45px" }}
                  >
                    {backupCommunicationsList.map((pm) => (
                      <MenuItem key={pm.id} value={pm.name}>
                        {pm.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
            </Stack>
          </Grid>

          <Grid item xs={12} style={{ paddingBottom: "3%" }}>
            <Stack direction="row" alignItems="center">
              <Typography variant="h6" style={{ minWidth: "35%" }}>
                Point to Point Antenna Package
              </Typography>

              <Box style={{ flexGrow: "1", minWidth: "60%" }}>
                <ToggleButtonGroup
                  color="primary"
                  value={pointTopointPackage}
                  exclusive
                  onChange={(event, newValue) => {
                    setPointTopointPackage(newValue);
                  }}
                  aria-label="Ack"
                  sx={{ paddingRight: "10%" }}
                >
                  <ToggleButton color="success" value={true}>
                    Yes
                  </ToggleButton>
                  <ToggleButton value={false}>No</ToggleButton>
                </ToggleButtonGroup>

                {pointTopointPackage ? (
                  <TextField
                    label="Point to Point Details"
                    name="pointTopointDetails"
                    value={pointTopointDetails}
                    onChange={(event) => {
                      setPointToPointDetails(event.target.value);
                    }}
                    style={{ minWidth: "26%" }}
                  />
                ) : null}
              </Box>
            </Stack>
          </Grid>

          <Grid item xs={12} style={{ paddingBottom: "3%" }}>
            <Stack direction="row" alignItems="center">
              <Typography variant="h6" style={{ minWidth: "35%" }}>
                Primary Ebutton
              </Typography>

              <Box style={{ flexGrow: "1", minWidth: "60%" }}>
                <ToggleButtonGroup
                  color="primary"
                  value={primaryEbutton}
                  exclusive
                  onChange={(event, newValue) => {
                    setPrimaryEbutton(newValue);
                  }}
                  aria-label="Ack"
                  sx={{ paddingRight: "10%" }}
                >
                  <ToggleButton color="success" value={true}>
                    Yes
                  </ToggleButton>
                  <ToggleButton value={false}>No</ToggleButton>
                </ToggleButtonGroup>

                {primaryEbutton ? (
                  <TextField
                    label="Primary Ebutton Details"
                    name="primaryEbuttonDetails"
                    value={primaryEbuttonDetails}
                    onChange={(event) => {
                      setPrimaryEbuttonDetails(event.target.value);
                    }}
                    style={{ minWidth: "26%" }}
                  />
                ) : null}
              </Box>
            </Stack>
          </Grid>

          { selectedUnit.value === "OW"
          ?
            <Grid item xs={12} style={{ paddingBottom: "3%" }}>
              <Stack direction="row" alignItems="center">
                <Typography variant="h6" style={{ minWidth: "35%" }}>
                  Sensor Package Type
                </Typography>

                <Box style={{ flexGrow: "1", minWidth: "60%" }}>
                  <FormControl sx={{ width: "40%" }}>
                    <Select
                      labelId="sensor package type"
                      id="sensor package type"
                      value={sensorPackageType}
                      onChange={(event) => {
                        setSensorPackageType(event.target.value);
                      }}
                      sx={{ padding: "0px", maxHeight: "45px" }}
                    >
                      {sensorPackageTypeList.map((pm) => (
                        <MenuItem key={pm.id} value={pm.name}>
                          {pm.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>
              </Stack>
            </Grid>
          : null
          }

          { selectedUnit.value !== "BSU" && selectedUnit.value !== "OW"
          ?
            <Grid item xs={12} style={{ paddingBottom: "3%" }}>
              <Stack direction="row" alignItems="center">
                <Typography variant="h6" style={{ minWidth: "35%" }}>
                  Plumbing Infrastructure Type
                </Typography>

                <Box style={{ flexGrow: "1", minWidth: "60%" }}>
                  <FormControl sx={{ width: "40%" }}>
                    <Select
                      labelId="plumbing infrastructure"
                      id="plumbing infrastructure"
                      value={plumbingInfrastructureType}
                      onChange={(event) => {
                        setPlumbingInfrastructureType(event.target.value);
                      }}
                      sx={{ padding: "0px", maxHeight: "45px" }}
                    >
                      {plumbingInfrastructureList.map((pm) => (
                        <MenuItem key={pm.id} value={pm.name}>
                          {pm.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>
              </Stack>
            </Grid>
          : null 
          }
          
          { selectedUnit.value !== "OW"
          ?
            <Grid item xs={12} style={{ paddingBottom: "3%" }}>
              <Stack direction="row" alignItems="center">
                <Typography variant="h6" style={{ minWidth: "35%" }}>
                  Valve Type Specified
                </Typography>

                <Box style={{ flexGrow: "1", minWidth: "60%" }}>
                  <FormControl sx={{ width: "40%" }}>
                    <Select
                      labelId="valve type"
                      id="valve type"
                      value={valveTypeSpecified}
                      onChange={(event) => {
                        setValveTypeSpecified(event.target.value);
                      }}
                      sx={{ padding: "0px", maxHeight: "45px" }}
                    >
                      {valveTypeList.map((pm) => (
                        <MenuItem key={pm.id} value={pm.name}>
                          {pm.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>
              </Stack>
            </Grid>
          : null
          }

          { selectedUnit.value === "BSU" && selectedUnit.value !== "OW"
          ?
            <Grid item xs={12} style={{ paddingBottom: "3%" }}>
              <Stack direction="row" alignItems="center">
                <Typography variant="h6" style={{ minWidth: "35%" }}>
                  Fire Alarm Panel Interconnect
                </Typography>

                <Box style={{ flexGrow: "1", minWidth: "60%" }}>
                  <ToggleButtonGroup
                    color="primary"
                    value={fireAlarmPanelInterconnect}
                    exclusive
                    onChange={(event, newValue) => {
                      setFireAlarmPanelInterconnect(newValue);
                    }}
                    aria-label="Ack"
                    sx={{ paddingRight: "10%" }}
                  >
                    <ToggleButton color="success" value={true}>
                      Yes
                    </ToggleButton>
                    <ToggleButton value={false}>No</ToggleButton>
                  </ToggleButtonGroup>
                </Box>
              </Stack>
            </Grid>
          : null
          }

          { selectedUnit.value !== "BSU" && selectedUnit.value !== "OW"
          ?
            <Grid item xs={12} style={{ paddingBottom: "3%" }}>
              <Stack direction="row" alignItems="center">
                <Typography variant="h6" style={{ minWidth: "35%" }}>
                  Riser Room Camera Specified
                </Typography>

                <Box style={{ flexGrow: "1", minWidth: "60%" }}>
                  <ToggleButtonGroup
                    color="primary"
                    value={riserRoomCamera}
                    exclusive
                    onChange={(event, newValue) => {
                      setRiserRoomCamera(newValue);
                    }}
                    aria-label="Ack"
                    sx={{ paddingRight: "10%" }}
                  >
                    <ToggleButton color="success" value={true}>
                      Yes
                    </ToggleButton>
                    <ToggleButton value={false}>No</ToggleButton>
                  </ToggleButtonGroup>
                </Box>
              </Stack>
            </Grid>
          : null
          }

            { selectedUnit.value === "BSU" && selectedUnit.value !== "OW"
            ?
              <Grid item xs={12} style={{ paddingBottom: "3%" }}>
                <Stack direction="row" alignItems="center">
                  <Typography variant="h6" style={{ minWidth: "35%", paddingRight: "1%" }}>
                    Make/Model of Fire Alarm Panel
                  </Typography>

                  <Box style={{ flexGrow: "1", minWidth: "60%" }}>
                    <TextField
                      label="make/modelFirePanel"
                      name="make/modelFirePanel"
                      value={makeModelFireAlarmPanel}
                      onChange={(event) => {
                        setMakeModelFireAlarmPanel(event.target.value);
                      }}
                      style={{ minWidth: "26%" }}
                    />
                  </Box>
                </Stack>
              </Grid>
            : null
            }

          { selectedUnit.value === "CF" && selectedUnit.value !== "OW"
          ?
          <>
            <Grid item xs={12} style={{ paddingBottom: "3%" }}>
              <Stack direction="row" alignItems="center">
                <Typography variant="h6" style={{ minWidth: "35%", paddingRight: "1%" }}>
                  Make/Model of Preaction Valve/Cabinet
                </Typography>

                <Box style={{ flexGrow: "1", minWidth: "60%" }}>
                  <TextField
                    label="make/modelValve"
                    name="make/modelValve"
                    value={makeModelPreactionValve}
                    onChange={(event) => {
                      setMakeModelPreactionValve(event.target.value);
                    }}
                    style={{ minWidth: "26%" }}
                  />
                </Box>
              </Stack>
            </Grid>

            <Grid item xs={12} style={{ paddingBottom: "3%" }}>
              <Stack direction="row" alignItems="center">
                <Typography variant="h6" style={{ minWidth: "35%" }}>
                  Make/Model of Preaction Panel
                </Typography>

                <Box style={{ flexGrow: "1", minWidth: "60%" }}>
                  <TextField
                    label="make/modelPanel"
                    name="make/modelPanel"
                    value={makeModelPreactionPanel}
                    onChange={(event) => {
                      setMakeModelPreactionPanel(event.target.value);
                    }}
                    style={{ minWidth: "26%" }}
                  />
                </Box>
              </Stack>
            </Grid>
          </>
          : null
          }

          { selectedUnit.value === "CF" && selectedUnit.value !== "OW"
          ?
            <Grid item xs={12} style={{ paddingBottom: "3%" }}>
              <Stack direction="row" alignItems="center">
                <Typography variant="h6" style={{ minWidth: "35%" }}>
                  Suppression Solution Inductor
                </Typography>

                <Box style={{ flexGrow: "1", minWidth: "60%" }}>
                  <ToggleButtonGroup
                    color="primary"
                    value={suppressionSolutionInductor}
                    exclusive
                    onChange={(event, newValue) => {
                      setSuppressionSolutionInductor(newValue);
                    }}
                    aria-label="Ack"
                    sx={{ paddingRight: "10%" }}
                  >
                    <ToggleButton color="success" value={true}>
                      Yes
                    </ToggleButton>
                    <ToggleButton value={false}>No</ToggleButton>
                  </ToggleButtonGroup>

                  {suppressionSolutionInductor && selectedUnit.value === "BSU"
                  ?
                    <FormControl sx={{ width: "40%" }}>
                      <Select
                        labelId="suppression selection"
                        id="suppression selection"
                        value={suppressionSolutionSelection}
                        label="suppressionSelection"
                        onChange={(event) => {
                          setSuppressionSolutionSelection(event.target.value);
                        }}
                        sx={{ padding: "0px", maxHeight: "45px" }}
                      >
                        {suppressionSolutionList.map((pm) => (
                          <MenuItem key={pm.id} value={pm.name}>
                            {pm.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  : null
                  }
                </Box>
              </Stack>
            </Grid>
          : null
          }

          { selectedUnit.value !== "OW"
          ?
            <Grid item xs={12} style={{ paddingBottom: "3%" }}>
              <Stack direction="row" alignItems="center">
                <Typography variant="h6" style={{ minWidth: "35%" }}>
                  Backup Power Generator
                </Typography>

                <Box style={{ flexGrow: "1", minWidth: "60%" }}>
                  <ToggleButtonGroup
                    color="primary"
                    value={backupPowerGenerator}
                    exclusive
                    onChange={(event, newValue) => {
                      setBackupPowerGenerator(newValue);
                    }}
                    aria-label="Ack"
                    sx={{ paddingRight: "10%" }}
                  >
                    <ToggleButton color="success" value={true}>
                      Yes
                    </ToggleButton>
                    <ToggleButton value={false}>No</ToggleButton>
                  </ToggleButtonGroup>
                </Box>
              </Stack>
            </Grid>
          : null
          }

          { selectedUnit.value === "BSU" && selectedUnit.value !== "OW"
          ?
            <>
              <Grid item xs={12} style={{ paddingBottom: "3%" }}>
                <Stack direction="row" alignItems="center">
                  <Typography variant="h6" style={{ minWidth: "35%" }}>
                    Cold Weather Package
                  </Typography>

                  <Box style={{ flexGrow: "1", minWidth: "60%" }}>
                    <ToggleButtonGroup
                      color="primary"
                      value={coldWeatherPackage}
                      exclusive
                      onChange={(event, newValue) => {
                        setColdWeatherPackage(newValue);
                      }}
                      aria-label="Ack"
                      sx={{ paddingRight: "10%" }}
                    >
                      <ToggleButton color="success" value={true}>
                        Yes
                      </ToggleButton>
                      <ToggleButton value={false}>No</ToggleButton>
                    </ToggleButtonGroup>
                  </Box>
                </Stack>
              </Grid>

              <Grid item xs={12} style={{ paddingBottom: "3%" }}>
                <Stack direction="row" alignItems="center">
                  <Typography variant="h6" style={{ minWidth: "35%" }}>
                    Cold Weather BSU
                  </Typography>

                  <Box style={{ flexGrow: "1", minWidth: "60%" }}>
                    <FormControl sx={{ width: "40%" }}>
                      <Select
                        labelId="cold weather bsu"
                        id="cold weather bsu"
                        value={coldWeatherBsu}
                        label="ColdWeatherBsu"
                        onChange={(event) => {
                          setColdWeatherBsu(event.target.value);
                        }}
                        sx={{ padding: "0px", maxHeight: "45px" }}
                      >
                        {coldWeatherBsuList.map((pm) => (
                          <MenuItem key={pm.id} value={pm.name}>
                            {pm.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>
                </Stack>
              </Grid>

              <Grid item xs={12} style={{ paddingBottom: "3%" }}>
                <Stack direction="row" alignItems="center">
                  <Typography variant="h6" style={{ minWidth: "35%" }}>
                    Conveyor Stop
                  </Typography>

                  <Box style={{ flexGrow: "1", minWidth: "60%" }}>
                    <ToggleButtonGroup
                      color="primary"
                      value={conveyorStop}
                      exclusive
                      onChange={(event, newValue) => {
                        setConveyorStop(newValue);
                      }}
                      aria-label="Ack"
                      sx={{ paddingRight: "10%" }}
                    >
                      <ToggleButton color="success" value={true}>
                        Yes
                      </ToggleButton>
                      <ToggleButton value={false}>No</ToggleButton>
                    </ToggleButtonGroup>
                  </Box>
                </Stack>
              </Grid>

              <Grid item xs={12} style={{ paddingBottom: "3%" }}>
                <Stack direction="row" alignItems="center">
                  <Typography variant="h6" style={{ minWidth: "35%" }}>
                    Arrangement Responsible for Conveyor Stop
                  </Typography>

                  <Box style={{ flexGrow: "1", minWidth: "60%" }}>
                    <FormControl sx={{ width: "40%" }}>
                      <Select
                        labelId="arrangement responsible for conveyor stop"
                        id="arrangement responsible for conveyor stop"
                        value={arrangementResponsibleForConveyorStop}
                        onChange={(event) => {
                          setArrangementResponsibleForConvStop(event.target.value);
                        }}
                        sx={{ padding: "0px", maxHeight: "45px" }}
                      >
                        {arrangementResponsibleForConvStopList.map((pm) => (
                          <MenuItem key={pm.id} value={pm.name}>
                            {pm.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>
                </Stack>
              </Grid>

              <Grid item xs={12} style={{ paddingBottom: "3%" }}>
                <Stack direction="row" alignItems="center">
                  <Typography variant="h6" style={{ minWidth: "35%" }}>
                    Conveyor Stop Detection Device
                  </Typography>

                  <Box style={{ flexGrow: "1", minWidth: "60%" }}>
                    <FormControl sx={{ width: "40%" }}>
                      <Select
                        labelId="conveyor stop detection device"
                        id="conveyor stop detection device"
                        value={conveyorStopDetectionDevice}
                        onChange={(event) => {
                          setConveyorStopDetectionDevice(event.target.value);
                        }}
                        sx={{ padding: "0px", maxHeight: "45px" }}
                      >
                        {conveyorStopDetectionDeviceList.map((pm) => (
                          <MenuItem key={pm.id} value={pm.name}>
                            {pm.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>
                </Stack>
              </Grid>

              <Grid item xs={12} style={{ paddingBottom: "3%" }}>
                <Stack direction="row" alignItems="center">
                  <Typography variant="h6" style={{ minWidth: "35%" }}>
                    Conveyor Stop Fire Rover Output``
                  </Typography>

                  <Box style={{ flexGrow: "1", minWidth: "60%" }}>
                    <FormControl sx={{ width: "40%" }}>
                      <Select
                        labelId="conveyor stop fire rover output"
                        id="conveyor stop fire rover output"
                        value={conveyorStopFireRoverOutput}
                        onChange={(event) => {
                          setConveyorStopFireRoverOutput(event.target.value);
                        }}
                        sx={{ padding: "0px", maxHeight: "45px" }}
                      >
                        {conveyorStopFireRoverOutputList.map((pm) => (
                          <MenuItem key={pm.id} value={pm.name}>
                            {pm.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>
                </Stack>
              </Grid>

              <Grid item xs={12} style={{ paddingBottom: "3%" }}>
                <Stack direction="row" alignItems="center">
                  <Typography variant="h6" style={{ minWidth: "35%" }}>
                    Conveyor Siren/Strobe
                  </Typography>

                  <Box style={{ flexGrow: "1", minWidth: "60%" }}>
                    <FormControl sx={{ width: "40%" }}>
                      <Select
                        labelId="conveyor siren strobe"
                        id="conveyor siren strobe"
                        value={conveyorSirenStrobe}
                        onChange={(event) => {
                          setConveyorSirenStrobe(event.target.value);
                        }}
                        sx={{ padding: "0px", maxHeight: "45px" }}
                      >
                        {conveyorSirenStrobeList.map((pm) => (
                          <MenuItem key={pm.id} value={pm.name}>
                            {pm.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>
                </Stack>
              </Grid>

              <Grid item xs={12} style={{ paddingBottom: "3%" }}>
                <Stack direction="row" alignItems="center">
                  <Typography variant="h6" style={{ minWidth: "35%" }}>
                    Conveyor Stop Siren Reset
                  </Typography>

                  <Box style={{ flexGrow: "1", minWidth: "60%" }}>
                    <ToggleButtonGroup
                      color="primary"
                      value={conveyorStopSirenReset}
                      exclusive
                      onChange={(event, newValue) => {
                        setConveyorStopSirenReset(newValue);
                      }}
                      aria-label="Ack"
                      sx={{ paddingRight: "10%" }}
                    >
                      <ToggleButton color="success" value={true}>
                        Yes
                      </ToggleButton>
                      <ToggleButton value={false}>No</ToggleButton>
                    </ToggleButtonGroup>
                  </Box>
                </Stack>
              </Grid>

              <Grid item xs={12} style={{ paddingBottom: "3%" }}>
                <Stack direction="row" alignItems="center">
                  <Typography variant="h6" style={{ minWidth: "35%" }}>
                    Conveyor Stop Siren Reset Input
                  </Typography>

                  <Box style={{ flexGrow: "1", minWidth: "60%" }}>
                    <FormControl sx={{ width: "40%" }}>
                      <Select
                        labelId="conveyor stop siren reset input"
                        id="conveyor stop siren reset input"
                        value={conveyorStopSirenResetInput}
                        onChange={(event) => {
                          setConveyorStopSirenResetInput(event.target.value);
                        }}
                        sx={{ padding: "0px", maxHeight: "45px" }}
                      >
                        {conveyorStopSirenResetInputList.map((pm) => (
                          <MenuItem key={pm.id} value={pm.name}>
                            {pm.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>
                </Stack>
              </Grid>
            </>
          : null
          }
        </Grid>
      </Box>

      { selectedUnit.value !== "OW"
      ?
        <>
        <Box mt={4}>
          <Typography variant="h4" gutterBottom>
            Output Terminal Function
          </Typography>
          <Divider />
          <Grid container spacing={2}>
            {outputConfigurations.map((config, index) => (
              <Grid item xs={12} style={{ paddingBottom: "3%", paddingTop: "8%" }} key={index}>
                <Stack direction="column" spacing={2}>
                  <Typography variant="h6">
                    Output {index + 1} Configuration
                    {index > 0 && (
                      <IconButton
                        onClick={() => removeOutputConfiguration(index)}
                        aria-label="delete"
                      >
                        <Tooltip title="Remove Output Configuration">
                          <DeleteIcon />
                        </Tooltip>
                      </IconButton>
                    )}
                  </Typography>


                  <Box style={{ flexGrow: "1", minWidth: "60%" }}>
                    <FormControl sx={{ width: "40%" }}>
                      <Select
                        labelId={`output-${index}`}
                        id={`output-${index}`}
                        value={config.value}
                        onChange={(event) =>
                          handleOutputChange(index, event.target.value)
                        }
                        sx={{ padding: "0px", maxHeight: "45px" }}
                      >
                        {outputConfigList.map((pm) => (
                          <MenuItem key={pm.id} value={pm.name}>
                            {pm.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>

                  {config.value === "Other" && (
                    <TextField
                      label="Trigger/Function"
                      value={config.otherOutputTrigger}
                      onChange={(event) =>
                        handleOtherTriggerChange(index, event.target.value)
                      }
                      fullWidth
                    />
                  )}

                  <Box style={{ flexGrow: "1", minWidth: "60%" }}>
                    <FormControl sx={{ width: "40%" }}>
                      <Select
                        labelId={"Circuit Type"}
                        id={"Circuit Type"}
                        value={config.circuitType}
                        onChange={(event) =>
                          handleOutputCircuitTypeChange(index, event.target.value)
                        }
                        sx={{ padding: "0px", maxHeight: "45px" }}
                      >
                        {circuitTypeList.map((pm) => (
                          <MenuItem key={pm.id} value={pm.name}>
                            {pm.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>

                  <Box style={{ flexGrow: "1", minWidth: "60%" }}>
                    <FormControl sx={{ width: "40%" }}>
                      <Select
                        labelId={"Circuit Method"}
                        id={"Circuit Method"}
                        value={config.circuitMethod}
                        onChange={(event) =>
                          handleOutputCircuitMethodChange(index, event.target.value)
                        }
                        sx={{ padding: "0px", maxHeight: "45px" }}
                      >
                        {circuitMethodList.map((pm) => (
                          <MenuItem key={pm.id} value={pm.name}>
                            {pm.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>

                  {config.circuitMethod === "Latching" && (
                    <TextField
                      label="Reset Method"
                      value={config.resetMethod}
                      onChange={(event) =>
                        handleOutputResetMethodChange(index, event.target.value)
                      }
                      fullWidth
                    />
                  )}

                  <Box mt={2} style={{ flexGrow: "1", minWidth: "10%" }}>
                    <TextField
                      label="Notes"
                      value={config.notes}
                      onChange={(event) =>
                        handleNotesChange(index, event.target.value)
                      }
                      fullWidth
                    />
                  </Box>
                </Stack>
              </Grid>
            ))}
            {outputConfigurations.length < 6 && (
              <Grid item xs={12} style={{ paddingBottom: "5%" }}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={addOutputConfiguration}
                >
                  Add Output Configuration
                </Button>
              </Grid>
            )}
          </Grid>
        </Box>

        <Box mt={4}>
          <Typography variant="h4" gutterBottom>
            Input Terminal Function
          </Typography>
          <Divider />
          <Grid container spacing={2}>
            {inputConfigurations.map((config, index) => (
              <Grid item xs={12} style={{ paddingBottom: "3%", paddingTop: "8%" }} key={index}>
                <Stack direction="column" spacing={2}>
                  <Typography variant="h6">
                    Input {index + 1} Configuration
                    {index > 0 && (
                    <IconButton
                      onClick={() => removeInputConfiguration(index)}
                      aria-label="delete"
                    >
                      <Tooltip title="Remove Input Configuration">
                        <DeleteIcon />
                      </Tooltip>
                    </IconButton>
                  )}
                  </Typography>

                  <Box style={{ flexGrow: "1", minWidth: "60%" }}>
                    <FormControl sx={{ width: "40%" }}>
                      <Select
                        labelId={`input-${index}`}
                        id={`input-${index}`}
                        value={config.value}
                        onChange={(event) =>
                          handleInputChange(index, event.target.value)
                        }
                        sx={{ padding: "0px", maxHeight: "45px" }}
                      >
                        {inputConfigList.map((pm) => (
                          <MenuItem key={pm.id} value={pm.name}>
                            {pm.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>

                  <Box style={{ flexGrow: "1", minWidth: "60%" }}>
                    <FormControl sx={{ width: "40%" }}>
                      <Select
                        labelId={"Circuit Type"}
                        id={"Circuit Type"}
                        value={config.circuitType}
                        onChange={(event) =>
                          handleInputCircuitTypeChange(index, event.target.value)
                        }
                        sx={{ padding: "0px", maxHeight: "45px" }}
                      >
                        {circuitTypeList.map((pm) => (
                          <MenuItem key={pm.id} value={pm.name}>
                            {pm.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>

                  <Box style={{ flexGrow: "1", minWidth: "60%" }}>
                    <FormControl sx={{ width: "40%" }}>
                      <Select
                        labelId={"Circuit Method"}
                        id={"Circuit Method"}
                        value={config.circuitMethod}
                        onChange={(event) =>
                          handleInputCircuitMethodChange(index, event.target.value)
                        }
                        sx={{ padding: "0px", maxHeight: "45px" }}
                      >
                        {circuitMethodList.map((pm) => (
                          <MenuItem key={pm.id} value={pm.name}>
                            {pm.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>

                  {config.circuitMethod === "Latching" && (
                    <TextField
                      label="Reset Method"
                      value={config.resetMethod}
                      onChange={(event) =>
                        handleInputResetMethodChange(index, event.target.value)
                      }
                      fullWidth
                    />
                  )}

                  <Box style={{ flexGrow: "1", minWidth: "60%" }}>
                    <FormControl sx={{ width: "40%" }}>
                      <Select
                        labelId={"Panel Action"}
                        id={"Panel Action"}
                        value={config.panelAction}
                        onChange={(event) =>
                          handleInputPanelActionChange(index, event.target.value)
                        }
                        sx={{ padding: "0px", maxHeight: "45px" }}
                      >
                        {inputPanelActionList.map((pm) => (
                          <MenuItem key={pm.id} value={pm.name}>
                            {pm.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>

                  <div style={{ display: "flex", alignItems: "center" }}>
                  <Typography variant="h6" style={{ paddingRight: "3%" }}>
                    Report to Central Station
                  </Typography>
                  <ToggleButtonGroup
                    color="primary"
                    value={config.reportToCs}
                    exclusive
                    onChange={(event, newValue) => {
                      handleReportToCsChange(index, newValue)
                    }}
                    aria-label="Report to CS"
                    sx={{ paddingRight: "5%" }}
                  >
                    <ToggleButton color="success" value={true}>
                      Yes
                    </ToggleButton>
                    <ToggleButton value={false}>No</ToggleButton>
                  </ToggleButtonGroup>
                  </div>

                  <Box mt={2} style={{ flexGrow: "1", minWidth: "60%" }}>
                    <TextField
                      label="Notes"
                      value={config.notes}
                      onChange={(event) =>
                        handleInputNotesChange(index, event.target.value)
                      }
                      fullWidth
                    />
                  </Box>
                </Stack>
              </Grid>
            ))}
            {inputConfigurations.length < 4 && (
              <Grid item xs={12} style={{ paddingBottom: "5%" }}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={addInputConfiguration}
                >
                  Add Input Configuration
                </Button>
              </Grid>
            )}
          </Grid>
        </Box>

        <Box mt={4}>
          <Typography variant="h4" gutterBottom>
            Auxillary Input Terminal Function
          </Typography>
          <Divider />
          <Grid container spacing={2}>
            {auxInputConfigurations.map((config, index) => (
              <Grid item xs={12} style={{ paddingBottom: "3%", paddingTop: "8%" }} key={index}>
                <Stack direction="row" alignItems="center">
                  <Typography variant="h6" style={{ minWidth: "30%" }}>
                    Aux Input {index + 1} Configuration
                  </Typography>

                  <Box style={{ flexGrow: "1", minWidth: "60%" }}>
                    <FormControl sx={{ width: "40%" }}>
                      <Select
                        labelId={`auxInput-${index}`}
                        id={`auxInput-${index}`}
                        value={config.value}
                        onChange={(event) =>
                          handleAuxInputChange(index, event.target.value)
                        }
                        sx={{ padding: "0px", maxHeight: "45px" }}
                      >
                        {inputConfigList.map((pm) => (
                          <MenuItem key={pm.id} value={pm.name}>
                            {pm.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>

                  {index > 0 && (
                    <IconButton
                      onClick={() => removeAuxInputConfiguration(index)}
                      aria-label="delete"
                    >
                      <DeleteIcon />
                    </IconButton>
                  )}
                </Stack>
                <Box mt={2} style={{ flexGrow: "1", minWidth: "60%" }}>
                  <TextField
                    label="Notes"
                    value={config.notes}
                    onChange={(event) =>
                      handleAuxInputNotesChange(index, event.target.value)
                    }
                    fullWidth
                  />
                </Box>
              </Grid>
            ))}
            {auxInputConfigurations.length < 6 && (
              <Grid item xs={12} style={{paddingBottom: "5%"}}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={addAuxInputConfiguration}
                >
                  Add Aux Input Configuration
                </Button>
              </Grid>
            )}
          </Grid>
        </Box>

        <Box mt={4}>
          <Typography variant="h4" gutterBottom>
            Viewing Station
          </Typography>
          <Divider />
          <Grid container spacing={2}>
            <Grid item xs={12} style={{ paddingBottom: "3%", paddingTop: "8%" }}>
              <Stack direction="row" alignItems="center">
                <Typography variant="h6" style={{ minWidth: "20%" }}>
                  Viewing Station
                </Typography>

                <Box style={{ flexGrow: "1", minWidth: "60%" }}>
                  <ToggleButtonGroup
                    color="primary"
                    value={viewingStation}
                    exclusive
                    onChange={(event, newValue) => {
                      setViewingStation(newValue);
                    }}
                    aria-label="Viewing Station"
                    sx={{ paddingRight: "5%" }}
                  >
                    <ToggleButton color="success" value={true}>
                      Yes
                    </ToggleButton>
                    <ToggleButton value={false}>No</ToggleButton>
                  </ToggleButtonGroup>

                  {viewingStation ? (
                    <>
                      <FormControl sx={{ width: "40%" }}>
                        <InputLabel id="pm-label">
                          Viewing Station Detail
                        </InputLabel>
                        <Select
                          labelId="pm-label"
                          id="pm-select"
                          value={viewingStationDetail}
                          onChange={(event) => {
                            setViewingStationDetail(event.target.value);
                          }}
                          sx={{ paddingTop: "0px", maxHeight: "45px" }}
                        >
                          {viewingStationDetailList.map((pm) => (
                            <MenuItem key={pm.id} value={pm.name}>
                              {pm.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>

                      <Box style={{ flexGrow: "1", minWidth: "60%", paddingTop: "3%" }}>
                        <TextField
                          label="viewing station location"
                          name="viewing station location"
                          value={viewingStationLocation}
                          onChange={(event) => {
                            setViewingStationLocation(event.target.value);
                          }}
                          style={{ minWidth: "40%" }}
                        />
                      </Box>
                    </>
                  ) : null}
                </Box>
              </Stack>
            </Grid>

            <Box mt={4}>
              <Typography variant="h4" gutterBottom>
                Other Custom Configuration Items
              </Typography>
              <Divider />
              <Grid container spacing={2}>
                {customConfigurations.map((config, index) => (
                  <Grid item xs={12} style={{ paddingBottom: "3%", paddingTop: "8%" }} key={index}>
                    <Stack direction="row" alignItems="center">
                      <Typography variant="h6" style={{ minWidth: "35%", paddingRight: "2%" }}>
                        Custom Configuration Item {index + 1}
                      </Typography>

                      <Box style={{ flexGrow: "1", minWidth: "60%" }}>
                        <TextField
                          label="Notes"
                          value={config.notes}
                          onChange={(event) => handleCustomNotesChange(index, event.target.value)}
                          fullWidth
                        />
                      </Box>

                      {index > 0 && (
                        <IconButton onClick={() => removeCustomConfiguration(index)} aria-label="delete">
                          <DeleteIcon />
                        </IconButton>
                      )}
                    </Stack>                  
                  </Grid>
                ))}
                {customConfigurations.length < 4 && (
                  <Grid item xs={12} style={{paddingBottom: "5%"}}>
                    <Button variant="contained" color="primary" onClick={addCustomConfiguration}>
                      Add Custom Configuration
                    </Button>
                  </Grid>
                )}
              </Grid>
            </Box>

            <Box mt={4}>
              <Typography variant="h4" gutterBottom>
                Other Production/Shipping/Install Notes
              </Typography>
              <Divider />
              <Grid container spacing={2}>
                {productionNoteConfigurations.map((config, index) => (
                  <Grid item xs={12} style={{ paddingBottom: "3%", paddingTop: "8%" }} key={index}>
                    <Stack direction="row" alignItems="center">
                      <Typography variant="h6" style={{ minWidth: "35%", paddingRight: "2%" }}>
                        Production/Shipping/Install Note {index + 1}
                      </Typography>

                      <Box style={{ flexGrow: "1", minWidth: "60%" }}>
                        <TextField
                          label="Notes"
                          value={config.notes}
                          onChange={(event) => handleProductionNotesChange(index, event.target.value)}
                          fullWidth
                        />
                      </Box>

                      {index > 0 && (
                        <IconButton onClick={() => removeProductionNoteConfiguration(index)} aria-label="delete">
                          <DeleteIcon />
                        </IconButton>
                      )}
                    </Stack>                  
                  </Grid>
                ))}
                {productionNoteConfigurations.length < 4 && (
                  <Grid item xs={12} style={{paddingBottom: "3%"}}>
                    <Button variant="contained" color="primary" onClick={addProductionNoteConfiguration}>
                      Add Production/Shipping/Install Note
                    </Button>
                  </Grid>
                )}
              </Grid>
            </Box>
          </Grid>
        </Box>
        </>
      : null
      }
    </>
  );
}